<template>
  <div class="loader" v-if="loading">
    <img src="@/assets/logo.png" alt="Logo" class="logo-loader" />

          <img src="@/assets/03-42-05-37_512.webp" alt="Logo" class="loader-loader" />
    
    
  </div>
  <div v-if="!isConnected" class="login-container">
    <div class="login-box">
          <img src="@/assets/logo.png" alt="Logo" class="logo__img" />
          <p class="login-kicker">Administration</p>
          <h2>Connexion Nyenyezia Forex</h2>
          <p class="login-subtitle">Gestion des marges et de la visibilité des taux.</p>
      <form @submit.prevent="handleSubmit">
        <p class="error-message" :class="errorMessage ? 'active' : ''">Mot de passe ou nom d'utilisateur incorrect.</p>
        <div class="textbox">
          <input
            type="text"
            v-model="username"
            placeholder="Nom d'utilisateur"
            required
          />
        </div>
        <div class="textbox">
          <input
            type="password"
            v-model="password"
            placeholder="Mot de passe"
            required
          />
        </div>
        <!-- <div class="checkbox">
          <label>
            <input type="checkbox" v-model="rememberMe" /> Se souvenir de moi
          </label>
        </div> -->
        <button type="submit" class="btn">Se connecter</button>
        <div class="forgot-password">
          <!-- <a href="#">Mot de passe oublié ?</a> -->
        </div>
      </form>
    </div>
  </div>
  <div v-else class="dashboard">
    <!-- Menu latéral -->
    <aside class="sidebar">
      <div class="logo admin-logo">
        <img src="@/assets/logo.png" alt="Logo" class="logo__img" />
        <span class="logo__text gold">Nyenyezia Forex</span>
        <small>Admin</small>
      </div>
      <h2>Taux de change</h2>
      <nav>
        <ul>
          <li :class="{ active: currentPage === 'devises_taux' }" @click="setCurrentPage('devises_taux')">
            <span class="nav-icon">FX</span> Devises
          </li>
        </ul> 
      </nav>
      <!-- <h2>Pages</h2>
      <nav>
        <ul>
          <li :class="{ active: currentPage === 'home' }" @click="setCurrentPage('home')">
            <i class="icon-home"></i> Accueil
          </li>
          <li :class="{ active: currentPage === 'about' }" @click="setCurrentPage('about')">
            <i class="icon-info"></i> À Propos
          </li>
          <li :class="{ active: currentPage === 'services' }" @click="setCurrentPage('services')">
            <i class="icon-briefcase"></i> Services
          </li>
          <li :class="{ active: currentPage === 'faq' }" @click="setCurrentPage('faq')">
            <i class="icon-question"></i> FAQ
          </li>
          <li :class="{ active: currentPage === 'contact' }" @click="setCurrentPage('contact')">
            <i class="icon-mail"></i> Contact
          </li>
          <li :class="{ active: currentPage === 'trading' }" @click="setCurrentPage('trading')">
            <i class="icon-chart"></i> Page de Trading
          </li>
        </ul>
      </nav> -->
      <h2>Fonctionnalités</h2>
      <nav>
        <ul>
          <li :class="{ active: currentPage === 'popups' }" @click="setCurrentPage('popups')">
            <span class="nav-icon">!</span> Popups / Annonces
          </li>
        </ul>
      </nav>
      <!-- <h2>Configurations</h2> -->
      <!-- <nav>
        <ul>
          <li :class="{ active: currentPage === 'profil' }" @click="setCurrentPage('profil')">
            <i class="icon-profil"></i> Profil
          </li>
          <li :class="{ active: currentPage === 'messages' }" @click="setCurrentPage('messages')">
            <i class="icon-messages"></i> Messages
          </li> 
        </ul>
      </nav-->
      <router-link to="/" class="return-link">
        <i class="icon-exit"></i> Retourner au site
      </router-link>
    </aside>

    <!-- Contenu principal -->
    <main class="main-content">
      <header class="header">

        <p class="admin-label">Administration Nyenyezia</p>
        <h1>{{ pages[currentPage]?.page_name ? pages[currentPage].page_name : currentPage }}</h1>
        <p class="header-help">{{ currentPage === 'popups' ? 'Gérez les annonces publiques affichées sur le site FR/EN.' : 'Modifiez les devises, marges et visibilités sans changer la formule de calcul.' }}</p>
      </header>
      <div v-if="notice.text" class="dashboard-notice" :class="notice.type">
        {{ notice.text }}
      </div>
      <section class="content">
        <PageEditor
          :key="currentPage + '-' + pageRefreshKey"
          :token="token"
          :setLoading="setLoading"
          :page="currentPage"
          @save="savePage"
          @notice="showNotice"
        />
      </section>
      <footer class="footer">
        <p>&copy; 2025 Nyenyezia Forex - Powered by Prismyk Inc.</p>
      </footer>
    </main>
  </div>
  <vue3-notify />
</template>

<script>
import PageEditor from './PageEditor.vue';
import axios from 'axios';
import Cookies from 'js-cookie';
import { apiUrl } from '@/config/api';

export default {
  name: 'DashboardPage',
  components: {
    PageEditor,
  },
  props: {
    adminInterface: Function,
  },
  async mounted() {
    const token = Cookies.get('authToken');
    this.token = token;
    if(token) {this.isConnected = true}
    this.adminInterface(true);
  },
  data() {
    return {
      token: null,
      loading: false,
      errorMessage: false,
      notice: {
        type: '',
        text: ''
      },
      username: "",
      password: "",
      rememberMe: false,
      isConnected: false,
      currentPage: 'devises_taux',
      pageRefreshKey: 0,
      pages: {
        devises_taux: {
          page_name: 'Devises',
          devises: {
            type: "currencyRates"
          }
        },
        profil: {
          page_name: 'Profil',
          profil: {
            type: "profil",
          }
        },
        popups: {
          page_name: 'Popups',
          popups: {
            type: "popups",
          }
        },
        // devises_taux: {
        //   page_name: 'Devises',
        //   devises: {
        //   type: "currencyRates",
        //   currenciesItems: {
        //     "AMD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Armenia", "country_name_fr": "Arménie" },
        //     "ANG": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Netherlands Antilles", "country_name_fr": "Antilles néerlandaises" },
        //     "ARS": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Argentina", "country_name_fr": "Argentine" },
        //     "AUD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Australia", "country_name_fr": "Australie" },
        //     "AWG": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Aruba", "country_name_fr": "Aruba" },
        //     "AZN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Azerbaijan", "country_name_fr": "Azerbaïdjan" },
        //     "BAM": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bosnia and Herzegovina", "country_name_fr": "Bosnie-Herzégovine" },
        //     "BBD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Barbados", "country_name_fr": "Barbade" },
        //     "BDT": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bangladesh", "country_name_fr": "Bangladesh" },
        //     "BGN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bulgaria", "country_name_fr": "Bulgarie" },
        //     "BHD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bahrain", "country_name_fr": "Bahreïn" },
        //     "BMD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bermuda", "country_name_fr": "Bermudes" },
        //     "BND": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Brunei", "country_name_fr": "Brunei" },
        //     "BOB": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bolivia", "country_name_fr": "Bolivie" },
        //     "BRL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Brazil", "country_name_fr": "Brésil" },
        //     "BSD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bahamas", "country_name_fr": "Bahamas" },
        //     //"BTC": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bitcoin", "country_name_fr": "Bitcoin" },
        //     "BTN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Bhutan", "country_name_fr": "Bhoutan" },
        //     "BYN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Belarus", "country_name_fr": "Biélorussie" },
        //     "BZD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Belize", "country_name_fr": "Belize" },
        //     "CAD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Canada", "country_name_fr": "Canada" },
        //     "CHF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Switzerland", "country_name_fr": "Suisse" },
        //     "CLP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Chile", "country_name_fr": "Chili" },
        //     "CNY": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "China", "country_name_fr": "Chine" },
        //     "COP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Colombia", "country_name_fr": "Colombie" },
        //     "CRC": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Costa Rica", "country_name_fr": "Costa Rica" },
        //     // "CUC": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Cuba", "country_name_fr": "Cuba" },
        //     "CUP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Cuba", "country_name_fr": "Cuba" },
        //     "CZK": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Czech Republic", "country_name_fr": "République tchèque" },
        //     "DJF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Djiboutian Franc", "country_name_fr": "Franc djiboutien" },
        //     "DKK": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Danish Krone", "country_name_fr": "Couronne danoise" },
        //     "DOP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Dominican Peso", "country_name_fr": "Peso dominicain" },
        //     "ERN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Eritrean Nakfa", "country_name_fr": "Nakfa érythréen" },
        //     "ETB": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Ethiopian Birr", "country_name_fr": "Birr éthiopien" },
        //     "EUR": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Euro", "country_name_fr": "Euro" },
        //     "FJD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Fijian Dollar", "country_name_fr": "Dollar fidjien" },
        //     "FKP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Falkland Islands Pound", "country_name_fr": "Livre des îles Falkland" },
        //     "FOK": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Faroese Króna", "country_name_fr": "Couronne féroïenne" },
        //     "GBP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "British Pound", "country_name_fr": "Livre sterling" },
        //     "GEL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Georgian Lari", "country_name_fr": "Lari géorgien" },
        //     "GGP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Guernsey Pound", "country_name_fr": "Livre de Guernesey" },
        //     "GIP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Gibraltar Pound", "country_name_fr": "Livre de Gibraltar" },
        //     "GTQ": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Guatemalan Quetzal", "country_name_fr": "Quetzal guatémaltèque" },
        //     "GYD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Guyanese Dollar", "country_name_fr": "Dollar guyanien" },
        //     "HKD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Hong Kong Dollar", "country_name_fr": "Dollar de Hong Kong" },
        //     "HNL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Honduran Lempira", "country_name_fr": "Lempira hondurien" },
        //     "HRK": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Croatian Kuna", "country_name_fr": "Kuna croate" },
        //     "HTG": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Haitian Gourde", "country_name_fr": "Gourde haïtien" },
        //     "HUF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Hungarian Forint", "country_name_fr": "Forint hongrois" },
        //     "IDR": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Indonesian Rupiah", "country_name_fr": "Roupie indonésienne" },
        //     "ILS": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Israeli New Shekel", "country_name_fr": "Nouveau shekel israélien" },
        //     "INR": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Indian Rupee", "country_name_fr": "Roupie indienne" },
        //     "IQD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Iraqi Dinar", "country_name_fr": "Dinar irakien" },
        //     "IRR": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Iranian Rial", "country_name_fr": "Rial iranien" },
        //     "ISK": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "Icelandic Króna", "country_name_fr": "Couronne islandaise" },
        //     "USD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_en": "United States", "country_name_fr": "États-Unis" },
        //     "AED": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Émirats arabes unis", "country_name_en": "United Arab Emirates" },
        //     "AFN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Afghanistan", "country_name_en": "Afghanistan" },
        //     "ALL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Albanie", "country_name_en": "Albania" },
        //     "BIF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Burundi", "country_name_en": "Burundi" },
        //     "RWF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Rwanda", "country_name_en": "Rwanda" },
        //     "ZAR": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Afrique du Sud", "country_name_en": "South Africa" },
        //     "XAF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Communauté Financière Africaine (BEAC)", "country_name_en": "Central African CFA" },
        //     "DZD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Algérie", "country_name_en": "Algeria" },
        //     "EGP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Égypte", "country_name_en": "Egypt" },
        //     "LYD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Libye", "country_name_en": "Libya" },
        //     "MAD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Maroc", "country_name_en": "Morocco" },
        //     "MRU": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Mauritanie", "country_name_en": "Mauritania" },
        //     "SDG": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Soudan", "country_name_en": "Sudan" },
        //     "TND": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Tunisie", "country_name_en": "Tunisia" },
        //     "XOF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Communauté Financière Africaine (BCEAO)", "country_name_en": "West African CFA" },
        //     "CVE": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Cap-Vert", "country_name_en": "Cape Verde" },
        //     "GMD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Gambie", "country_name_en": "Gambia" },
        //     "GHS": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Ghana", "country_name_en": "Ghana" },
        //     "GNF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Guinée", "country_name_en": "Guinea" },
        //     "LRD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Libéria", "country_name_en": "Liberia" },
        //     "NGN": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Nigéria", "country_name_en": "Nigeria" },
        //     "SLE": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Sierra Leone", "country_name_en": "Sierra Leone" },
        //     "CDF": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "République Démocratique du Congo", "country_name_en": "Democratic Republic of the Congo" },
        //     "KES": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Kenya", "country_name_en": "Kenya" },
        //     "TZS": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Tanzanie", "country_name_en": "Tanzania" },
        //     "UGX": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Ouganda", "country_name_en": "Uganda" },
        //     "ZMW": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Zambie", "country_name_en": "Zambia" },
        //     "ZWL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Zimbabwe", "country_name_en": "Zimbabwe" },
        //     "AOA": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Angola", "country_name_en": "Angola" },
        //     "BWP": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Botswana", "country_name_en": "Botswana" },
        //     "SZL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Eswatini", "country_name_en": "Eswatini" },
        //     "LSL": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Lesotho", "country_name_en": "Lesotho" },
        //     "NAD": { board1: false, board2: false, home: true, principale: true, autre: false, "buyMargin": 0.03, "sellMargin": 0.03, "country_name_fr": "Namibie", "country_name_en": "Namibia" }
        //     }
        //  },
        // },
        home: {
          page_name: 'Page D\'accueil',
          headerBanner: {
            type: 'image',
            src: 'hero-bg.a544aac0.jpg'
          },
          title: {
            type: 'text',
            content_fr: 'Services Fiables d\'Échange de Devises',
            content_en: 'Reliable Currency Exchange Services',
            color: "#001041"

          }, 
          soustitre: {
            type: 'text',
            content_fr: 'Nyenyezia Forex offre des solutions d\'échange de devises rapides, sécurisées et fiables.',
            content_en: 'Nyenyezia Forex offers fast, secure, and reliable currency exchange solutions.',
            color: "#001041"
          }, 
          btnCommencer: {
            type: "button",
            text_en: "Start",
            text_fr: "Commencer",
            to: "/services"
          },
          titreTauxDeChange: {
            type: 'text',
            content_fr: "Taux de Change",
            content_en: "Taux de Change",
            color: "#c39446"
          },
          services: {
            type: 'services',
            servicesItems: [
              {
                name: "Échange de devises",
                description: "Convertissez facilement vos devises avec des taux compétitifs.",
                icon: "/icons/exchange.png"
              },
              {
                name: "Transfert d'argent",
                description: "Envoyez de l'argent rapidement et en toute sécurité.",
                icon: "/icons/transfer.png"
              }
            ]
          },
          faq: {
            type: 'faq',
            faqItems: [
              {
                question_fr: "Comment puis-je échanger des devises ?",
                question_en: "How can I exchange currencies?",
                answer_fr: "Vous pouvez échanger des devises facilement sur notre plateforme en vous inscrivant et en suivant les étapes d'échange.",
                answer_en: "You can exchange currencies easily on our platform by signing up and following the exchange steps."
              },
              {
                question_fr: "Quels sont les frais de transaction ?",
                question_en: "What are the transaction fees?",
                answer_fr: "Les frais de transaction sont transparents et sont clairement affichés avant toute opération.",
                answer_en: "Transaction fees are transparent and clearly displayed before any transaction."
              },
              {
                question_fr: "Est-ce que le service est sécurisé ?",
                question_en: "Is the service secure?",
                answer_fr: "Oui, nous utilisons les meilleures technologies de sécurité pour protéger vos informations et vos transactions.",
                answer_en: "Yes, we use the best security technologies to protect your information and transactions."
              },
              {
                question_fr: "Puis-je échanger des devises à tout moment ?",
                question_en: "Can I exchange currencies anytime?",
                answer_fr: "Oui, notre plateforme est disponible 24/7 pour vous permettre d'échanger des devises à tout moment.",
                answer_en: "Yes, our platform is available 24/7 to allow you to exchange currencies anytime."
              }
            ]
          }
        },
        about: { title: 'À Propos de Nyenyezia Forex', content: 'Nous sommes une plateforme de trading de devises de confiance.' },
        services: { title: 'Nos Services', content: 'Offre de trading de devises, conseils financiers et plus.' },
        faq: { title: 'Foire aux Questions', content: 'Réponses aux questions fréquemment posées.' },
        contact: { title: 'Contactez-Nous', content: 'Adresse, téléphone et email pour nous joindre.' },
        trading: { title: 'Page de Trading', content: 'Accédez à notre plateforme de trading en temps réel.' },
      },
    };
  },
  methods: {
    setLoading (isLoading) {
      this.loading = isLoading;
    },
    showNotice(notice) {
      this.notice = notice || { type: '', text: '' };
      if (this.notice.text) {
        window.setTimeout(() => {
          this.notice = { type: '', text: '' };
        }, 5000);
      }
    },
    async getPage (name) {
      var config = {
        method: 'get',
        url: apiUrl('/page?name=' + encodeURIComponent(name)),
        headers: { 
          'Content-Type': 'application/json'
        }
      };

      return await axios(config)
      .then(function (response) {
        const config = response?.data?.config || null;
        return JSON.parse(config);
      })
      .catch(function (error) {
        return error;
      });

    },
    async loadPageConfig(name) {
      if (!this.pages[name]) return;
      this.loading = true;
      try {
        const config = await this.getPage(name === 'popups' ? 'home' : name);
        if (config && !config.message && !(config instanceof Error)) {
          if (name === 'popups') {
            this.pages.popups.popups = {
              ...this.pages.popups.popups,
              ...(config.site_popup || {})
            };
          } else {
            this.pages[name] = {
              ...this.pages[name],
              ...config
            };
          }
          this.pageRefreshKey += 1;
        }
      } catch (error) {
        console.error(error);
        this.showNotice({
          type: 'error',
          text: 'Impossible de charger la configuration. Les valeurs par défaut restent affichées.'
        });
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      // Simuler une action de connexion
      this.loading = true;
      if (this.username && this.password) {
        this.errorMessage = false;
        const config = {
          method: 'post',
          url: apiUrl('/admin/login'),
          headers: { 
            'Content-Type': 'application/json'
          },
          data: {
            username: this.username,
            password: this.password
          }
        };
        const resp = await axios(config)
        .then(function (response) {
          return response
        })
        .catch((error) => {
          console.log(error);
          this.errorMessage = true;
        });
        if(resp?.data?.token) {
            this.errorMessage = false;
            const token = resp.data.token;
            Cookies.set('authToken', token, { expires: 7 }); // expires en jours
            this.token = token;
            this.isConnected = true;
          } else {
            this.errorMessage = true;
          }
      } else {
        alert("Veuillez remplir tous les champs.");
      }
      this.loading = false;

    },
    async setCurrentPage(page) {
      this.currentPage = page;
      this.notice = { type: '', text: '' };
      if (page === 'popups') {
        await this.loadPageConfig(page);
      }
    },
    savePage(pageData) {
      this.pages[this.currentPage] = pageData;
      this.showNotice({
        type: 'success',
        text: 'Configuration enregistrée avec succès.'
      });
    },
  },
};
</script>

<style scoped>
.logo-loader {
  width: 200px;
  position: absolute;
  max-width: 90%;
  left: calc(50% + 25px);
  top: calc(50% - 50px);
  transform: translate(-50%, -50%);
  z-index: 10010;

}
.loader-loader {
  width: 200px;
  position: absolute;
  max-width: 90%;
  left: 50%;
  top: calc(50% + 50px);
  transform: translate(-50%, -50%);
  z-index: 10010;

}
.loader {
  background: rgba(0,0,0,.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
}
.error-message {
  color: red;
  display: none;
}
.error-message.active {
  display: initial;
}
/* Base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
  background-color: #f4f6f8;

  height: 100vh;
  color: #333;
}

.login-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  align-items: center;
  height: 100%;
  z-index: 1;
}

.login-box {
  background-color: #fff;
    padding: 28px;
    border-radius: 8px;
    border: 1px solid #d9dee7;
    box-shadow: 0 18px 46px rgba(0, 16, 65, 0.16);
    width: 360px;
    max-width: calc(100vw - 32px);
    text-align: center;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}

h2 {
  font-size: 24px;
  margin: 0 0 10px;
}

.login-kicker,
.admin-label {
  color: #c39446;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0;
  margin: 0 0 8px;
  text-transform: uppercase;
}

.login-subtitle {
  color: #555;
  font-size: 0.95rem;
  margin: 0 0 20px;
}

.textbox {
  margin: 10px 0;
}

.textbox input {
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 12px;
  width: 100%;
}

.checkbox {
  margin: 10px 0;
  text-align: left;
}

.btn {
  width: 100%;
  padding: 12px;
  background-color: #001041;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #c39446;
}

.error-message {
  background: #fff0f0;
  border: 1px solid #e2b1b1;
  border-radius: 6px;
  color: #8b1e1e;
  display: none;
  font-size: 0.9rem;
  margin: 0 0 14px;
  padding: 10px;
}

.error-message.active {
  display: block;
}

.forgot-password {
  margin-top: 10px;
  font-size: 14px;
}

.forgot-password a {
  color: #007bff;
  text-decoration: none;
}

.forgot-password a:hover {
  text-decoration: underline;
}

/* Logo Styles */
.logo {
  text-decoration: none !important;
  margin: 10px 0 20px;
}

.logo__anchor {
  text-decoration: none;
}

.logo__img {
  height: 36px;
  margin-bottom: 12px;
}

.logo__text {
  font-size: 16px;
  font-weight: bold;
}

.gold {
  color: #c39446;
}
/* Mise en page */
.dashboard {
  display: flex;
  min-height: 100vh;
  font-family: 'Arial', sans-serif;
  background-color: #f4f6f8;
  color: #333;
}

.sidebar {
  width: 250px;
  background-color: #001041;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar h2 {
  margin-bottom: 20px;
  font-size: 1.5rem;
  font-weight: bold;
  color: #d9c28a;
  text-align: left;
}

.sidebar nav ul {
  list-style: none;
  padding: 0;
  width: 100%;
}

.sidebar nav ul li {
  padding: 15px 20px;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 8px;
  transition: background 0.3s, color 0.3s;
}

.sidebar nav ul li i {
  margin-right: 10px;
}

.sidebar nav ul li:hover,
.sidebar nav ul li.active {
  background-color: #c39446;
  color: #001041;
}

.return-link {
  margin-top: 15px;
  background: #fff;
  padding: 10px 10px;
  border-radius: 10px;
  color: #001041;
  text-decoration: none;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  transition: color 0.3s;
  border:1px solid #001041;
  transition: background 0.3s, color 0.3s;
}

.return-link i {
  margin-right: 8px;
}

.return-link:hover {
  background: #c39446;
  color: #001041;
}

/* Contenu principal */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.header {
  padding: 22px 28px;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.header h1 {
  margin: 0;
  font-size: 1.8rem;
}

.content {
  flex: 1;
  padding: 20px;
  width: 100%;
  max-width: calc(100% - 50px);
}

.footer {
  text-align: center;
  padding: 10px;
  background-color: #fff;
  border-top: 1px solid #e5e5e5;
  color: #888;
}

/* Animations */
.sidebar nav ul li,
.return-link {
  opacity: 0;
  transform: translateX(-20px);
  animation: fadeIn 0.5s forwards;
}

.sidebar nav ul li:nth-child(1) {
  animation-delay: 0.1s;
}
.sidebar nav ul li:nth-child(2) {
  animation-delay: 0.2s;
}
.sidebar nav ul li:nth-child(3) {
  animation-delay: 0.3s;
}
.sidebar nav ul li:nth-child(4) {
  animation-delay: 0.4s;
}
.sidebar nav ul li:nth-child(5) {
  animation-delay: 0.5s;
}
.sidebar nav ul li:nth-child(6) {
  animation-delay: 0.6s;
}
.return-link {
  animation-delay: 0.7s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.admin-logo {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 14px;
}

.admin-logo small {
  color: #cfd9e8;
  display: block;
  font-size: 0.76rem;
  margin-top: 4px;
  text-transform: uppercase;
}

.nav-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 800;
  height: 26px;
  justify-content: center;
  margin-right: 10px;
  width: 32px;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
}

.sidebar h2 {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 0.78rem;
  letter-spacing: 0;
  margin: 18px 0 8px;
  padding-top: 18px;
  text-transform: uppercase;
}

.sidebar nav ul li {
  font-size: 0.95rem;
  margin: 6px 0;
  padding: 12px 14px;
}

.main-content {
  min-width: 0;
}

.header {
  border-bottom: 1px solid #dbe3ef;
  box-shadow: none;
  position: sticky;
  top: 0;
  z-index: 20;
}

.header-help {
  color: #53647c;
  margin: 8px 0 0;
}

.dashboard-notice {
  border-radius: 8px;
  margin: 18px 28px 0;
  padding: 13px 14px;
}

.dashboard-notice.success {
  background: #eefbf3;
  border: 1px solid #b9e5c7;
  color: #166534;
}

.dashboard-notice.error {
  background: #fff3f2;
  border: 1px solid #f0c3bd;
  color: #8b1e1e;
}

.content {
  max-width: none;
  padding: 24px 28px 34px;
}

.return-link {
  font-size: 0.95rem;
  justify-content: center;
  margin-top: auto;
}

@media (max-width: 900px) {
  .dashboard {
    display: block;
  }

  .sidebar {
    height: auto;
    position: static;
    width: 100%;
  }

  .sidebar nav ul {
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sidebar nav ul li {
    margin: 0;
  }

  .return-link {
    margin-top: 16px;
  }

  .header {
    position: static;
  }

  .dashboard-notice {
    margin: 14px 14px 0;
  }

  .content {
    padding: 16px 14px 28px;
  }
}

@media (max-width: 560px) {
  .sidebar nav ul {
    grid-template-columns: 1fr;
  }
}
</style>
